import AttToken from '../../helpers/attToken';
import Clients from '../../service/Clients';
import { Button, Skeleton, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { trackEventMatomo } from '../../helpers/matomo';
import QueryFn from '../../helpers/QueryFn';
import GenericAcordonPlaces from '../GenericAcordeonPlaces/GenericAcordeonPlaces';
import { useEffect } from 'react';

type props = {
  setSelectedTipoNotifica: Function
  tipoServico: string;
  setShowingAssociation: Function;
  nomeServico: string;
  setCnjsArrNotifica: Function,
  cnjsArrNotifica: any[]
  notificaSobre: any
};

const CustomerService = new Clients();
const queryFn = new QueryFn();

export default function TypePlaceNotification({
  tipoServico,
  setShowingAssociation,
  nomeServico,
  setCnjsArrNotifica,
  cnjsArrNotifica,
  setSelectedTipoNotifica,
  notificaSobre }: props) {
  const { t } = useTranslation('translation');
  const thisTipoLocal = notificaSobre ? notificaSobre.find((e: any) => e.tipo === tipoServico) || null : null;
  const { data, isLoading, isFetching } = queryFn.useFetch('GET_CLIENTES_CHILDREN',
    async () => {
      try {
        const data = await AttToken();
        if (data) {
          const teams = await CustomerService.getAllWithSets(data, tipoServico);
          return teams;
        } else throw new Error('aaaa');
      } catch (err) {
        console.error(err);
      }
    },
  );

  useEffect(() => {
    setCnjsArrNotifica(thisTipoLocal?.cnjs);
  }, []);

  useEffect(() => {
    thisTipoLocal.cnjs = cnjsArrNotifica;
  }, [cnjsArrNotifica]);

  if (isFetching || isLoading) return (
    <Stack
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={2}
    >
      <Stack
        width='100%'
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Skeleton variant='rounded' sx={{ width: '250px' }} height={25} />
        <Skeleton variant='rounded' sx={{ width: '200px' }} height={30} />
      </Stack>
      <Skeleton variant='rounded' sx={{ width: '300px' }} height={25} />
      <Skeleton variant='rounded' sx={{ width: '100%' }} height={60} />
    </Stack>
  );

  return (
    <>
      <Stack
        width='100%'
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={2.5}
      >
        <h1>{`${nomeServico}`}</h1>
        <Button
          startIcon={<ArrowBackIcon />}
          className="button"
          onClick={() => {
            setShowingAssociation(false);
            trackEventMatomo('modal associação de local', 'click', 'button', 'fecha modal');
            setSelectedTipoNotifica('');
          }}
        >
          {t('teamManage.registered.voltar')}
        </Button>
      </Stack>
      <h1>{t('teamManage.registered.AssociacaoConjuntos')}</h1>
      <GenericAcordonPlaces
        clients={data}
        isLoading={isLoading || isFetching}
        conjuntosArray={cnjsArrNotifica}
        setConjuntosArray={setCnjsArrNotifica} />
    </>
  );
}
